<div data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">{{ context.title | translate }}</h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body" #categoryForm>
    <form [formGroup]="form">
      <div data-test-id="wrap-category-title-element" *ngIf="isSubcategory" class="category-title">
        <div class="row">
          <label class="form-label">{{ 'PARENT_CATEGORY_HINT' | translate }}</label>
        </div>
        <div class="row">
          <input
            [value]="category.parent_title"
            type="text"
            [ngbTypeahead]="searchParentCategories"
            [inputFormatter]="formatParentCategory"
            [resultFormatter]="formatParentCategory"
            [editable]="false"
            (selectItem)="onSelectParentCategory($event)"
            (input)="onParentCategoryInput($event)"
            class="form-control"
            id="parentId"
            name="parentId"
            placeholder="Type to select parent node."
            [class.is-invalid]="form.get('parentId').invalid && form.get('parentId').touched"
            (blur)="onParentCategoryInputBlur()"
            data-test-id="parent-category-element"
          />
        </div>
        <!-- Parent id errors -->
        <small
          class="text-danger"
          data-test-id="error-message"
          *ngIf="form.get('parentId').errors && form.get('parentId').touched"
        >
          <ng-container>
            {{ 'INVALID_PARENT_ID_ERROR' | translate }}
          </ng-container>
        </small>
      </div>
      <div data-test-id="wrap-category-title-element" #categoryTitle class="category-title">
        <div class="row">
          <label class="form-label">{{ 'CATEGORY_TITLE_LABEL' | translate }} *</label>
        </div>
        <div class="row">
          <input
            type="text"
            formControlName="categoryTitle"
            class="form-control"
            id="categoryTitle"
            name="categoryTitle"
            placeholder="Enter new title. Each word with a capital letter."
            (blur)="trimTitle()"
            (keydown)="onKeyDown()"
            [class.is-invalid]="form.get('categoryTitle').invalid && form.get('categoryTitle').touched"
            data-test-id="category-title-element"
          />
        </div>
      </div>

      <!-- Display error message for category title -->
      <small
        class="text-danger"
        data-test-id="error-message"
        *ngIf="form.get('categoryTitle').errors && form.get('categoryTitle').touched"
      >
        <ng-container>
          {{ 'INVALID_CATEGORY_TITLE_ERROR' | translate }}
        </ng-container>
      </small>

      <div #formButtons class="form-buttons">
        <button
          data-test-id="submnit-button"
          class="btn btn-primary text-white"
          type="submit"
          (click)="submit()"
          [disabled]="form.invalid"
        >
          {{ 'BTN_SUBMIT_HINT' | translate }}
        </button>
        <button data-test-id="cancel-button" class="btn btn-secondary text-white" type="button" (click)="onDismiss()">
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="modal-footer" data-test-id="modal-footer"></div>
</div>
